import { getElementSignature } from '@core/integrations-legacy';
import type { IntegrationsElement } from '@core/integrations-types';
import { createEntityCollectionStore } from '@core/ngrx-legacy';

const { actions, namespace, selectors, reducer } =
  createEntityCollectionStore<IntegrationsElement>()('IntegrationJobBoards', {
    idSelector: getElementSignature,
    customActions: _adapter => ({}),
  });

export {
  actions as IntegrationJobBoardActions,
  namespace as IntegrationJobBoardNamespace,
  reducer as IntegrationJobBoardReducer,
  selectors as IntegrationJobBoardSelectors,
};
